export default "__VITE_ASSET__CgVbKM_G__"